<section class="faq-section" *ngIf="faqSection && faqSection.faqActive">
    <h2 id="faqSection" class="center section-title sub-heading" [innerHTML]="faqSection?.heading"></h2>
    <div class="center expandAll">
      <p><a *ngIf="label" href="javascript:;" [attr.aria-expanded]="expandAllFaqs"
        (click)="toggleExpandAll()" [innerHTML]="label"></a></p>
    </div>
    <div class="content floatclear">
      <div class="col">
        <app-matlist [expandAll]="expandAll" *ngFor="let faq of faqSection?.faqs;let faqIndex=index;"
          [header]="faq.navTitle | safeHtml" [content]="faq.content | safeHtml" [item]="faqIndex"
          (click)="onFAQClick(faqIndex, faq.navTitle)" [sectionFaq]="'citishopFaq'" #citishopFaq></app-matlist>
      </div>
    </div>
    <div class="center seeallFaq">
      <p><a *ngIf="faqSection?.sellAllFaqs" tabindex="0" role="link" [attr.aria-label]="faqSection?.sellAllFaqs"
      [innerHTML]="faqSection?.sellAllFaqs" (click)="onSeeAllFAQsClick()"
      (keyup.Enter)="onSeeAllFAQsClick()"></a>
    </p>
    <svg class="docSvg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="icon">
      <title id="icon">PDF</title>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.276 6h-.76a.5.5 0 0 0-.5.5V10a.5.5 0 0 0 .5.5h.678c1.362 0 2.152-.83 2.152-2.28 0-1.41-.761-2.22-2.07-2.22Zm-.02 3.77h-.471V6.72h.459c1.102 0 1.33.82 1.33 1.51 0 1.04-.428 1.54-1.318 1.54Z"
        fill="#056DAE"
      ></path>
      <path
        d="M15.035 10.115V6.5a.5.5 0 0 1 .5-.5h1.91a.36.36 0 0 1 0 .72h-1.639v1.09h.784a.365.365 0 0 1 0 .73h-.784v1.575a.385.385 0 0 1-.77 0Z"
        fill="#056DAE"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.5 6h1.22c.92 0 1.49.54 1.49 1.4 0 .88-.61 1.45-1.57 1.45h-.87v1.265a.385.385 0 0 1-.771 0V6.5a.5.5 0 0 1 .5-.5Zm.27 2.12h.87c.56 0 .8-.21.8-.7 0-.46-.25-.7-.74-.7h-.93v1.4Z"
        fill="#056DAE"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.5 0h-14A1.5 1.5 0 0 0 4 1.5v21A1.5 1.5 0 0 0 5.5 24h6.182c.218 0 .433-.048.631-.14l7.819-3.634c.529-.245.868-.776.868-1.359V1.5A1.5 1.5 0 0 0 19.5 0ZM12 22.903V20.5a.5.5 0 0 1 .5-.5h5.748L12 22.903ZM5 1.5v21a.5.5 0 0 0 .5.5H11v-2.5a1.5 1.5 0 0 1 1.5-1.5h7.461a.527.527 0 0 1 .015-.041.243.243 0 0 0 .024-.092V1.5a.5.5 0 0 0-.5-.5h-14a.5.5 0 0 0-.5.5Z"
        fill="#056DAE"
      ></path>
    </svg>
  </div>
</section>